import CryptoJS from "crypto-js";
import { APP_CRYPTO_IV, APP_CRYPTO_KEY } from "@ipru-common/constants/SiteConstants";
import ENV from "@ipru-common/config/environment/constant";
import { MIDDLEWARE, NON_MIDDLEWARE, TD_QDATA } from "@ipru-common/services/ApiEndpoints";

export const jwtApiKey = {
  [MIDDLEWARE]: ENV().REACT_APP_JBK,
  [NON_MIDDLEWARE]: ENV().REACT_APP_JNMBK,
  [TD_QDATA]: ENV().REACT_APP_TDQ,
};

export const getClientId = (middlewareType) => {
  const raw = jwtApiKey?.[middlewareType];
  if (!raw) return "";
  if (middlewareType === TD_QDATA) {
    return raw;
  }
  return base64Decode(raw).split(":")[0];
};

export const decryptCryptoJs = (ciphertext) => {
  let decryptedResponse = "";

  const ciphertextWA = CryptoJS.enc.Base64.parse(ciphertext);
  const keyWA = CryptoJS.enc.Utf8.parse(APP_CRYPTO_KEY);
  const ivWA = CryptoJS.enc.Utf8.parse(APP_CRYPTO_IV);
  const ciphertextCP = { ciphertext: ciphertextWA };
  const decrypted = CryptoJS.AES.decrypt(ciphertextCP, keyWA, { iv: ivWA });

  decryptedResponse = decrypted.toString(CryptoJS.enc.Utf8) || "";

  return decryptedResponse;
};
export const arrayBufferToBase64Crypto = (buffer) => btoa(String.fromCharCode(...new Uint8Array(buffer)));
export const arrayBufferToBase64CryptoSafe = (buffer) =>
  btoa(Array.from(new Uint8Array(buffer), (b) => String.fromCharCode(b)).join(""));
export const base64ToArrayBufferCrypto = (base64) => Uint8Array.from(atob(base64), (char) => char.charCodeAt(0)).buffer;
export const strToArrayBuffer = (input) => new TextEncoder().encode(input);

export const getKeyAndIV = async (jwt) => {
  const key = jwt;
  const iv = jwt.slice(-16); // Last 16 characters for IV
  return {
    key: await crypto.subtle.importKey("raw", strToArrayBuffer(key), { name: "AES-CBC" }, false, [
      "encrypt",
      "decrypt",
    ]),
    iv: strToArrayBuffer(iv),
  };
};

export const encryptCrypto = async (text, jwt, safeBase64Encoding = false) => {
  const { key, iv } = await getKeyAndIV(jwt);
  const encrypted = await crypto.subtle.encrypt({ name: "AES-CBC", iv }, key, strToArrayBuffer(text));
  return safeBase64Encoding ? arrayBufferToBase64CryptoSafe(encrypted) : arrayBufferToBase64Crypto(encrypted);
};

export const encryptCryptoJson = async (jsonData, middlewareType = MIDDLEWARE, safeBase64Encoding = false) => {
  const jwt = getClientId(middlewareType);
  const result = await encryptCrypto(JSON.stringify(jsonData), jwt, safeBase64Encoding);
  return result;
};

export const decryptCrypto = async (encryptResp, middlewareType = MIDDLEWARE) => {
  const jwt = getClientId(middlewareType);
  const { key, iv } = await getKeyAndIV(jwt);
  const decrypted = await crypto.subtle.decrypt(
    {
      name: "AES-CBC",
      iv,
    },
    key,
    base64ToArrayBufferCrypto(encryptResp)
  );
  return new TextDecoder().decode(decrypted);
};

export const base64Decode = (input) => atob(input);
